module.exports = __webpack_public_path__ + "static/img/codeTraceability.6818491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/codeTraceability.png
// module id = jbI8
// module chunks = 0